export default "__VITE_ASSET__513a99e2__"